package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SchoolAnalyticsResponse(
    val timestamp: String = "",
    val school: SchoolAnalyticsSchool = SchoolAnalyticsSchool(),
    @SerialName("current_academic_year")
    val currentAcademicYear: SchoolAnalyticsCurrentYear? = null,
    val metrics: SchoolAnalyticsMetrics = SchoolAnalyticsMetrics()
)

@Serializable
data class SchoolAnalyticsCurrentYear(
    val label: String = ""
)

@Serializable
data class SchoolAnalyticsSchool(
    val code: String = "",
    val name: String = ""
)

@Serializable
data class SchoolAnalyticsMetrics(
    val students: SchoolAnalyticsStudentMetrics = SchoolAnalyticsStudentMetrics(),
    val staff: SchoolAnalyticsStaffMetrics = SchoolAnalyticsStaffMetrics(),
    @SerialName("academic_years")
    val academicYears: SchoolAnalyticsAcademicYearMetrics = SchoolAnalyticsAcademicYearMetrics(),
    val subjects: SchoolAnalyticsSubjectMetrics = SchoolAnalyticsSubjectMetrics(),
    val classes: SchoolAnalyticsSubjectMetrics = SchoolAnalyticsSubjectMetrics(),
    val parents: SchoolAnalyticsSubjectMetrics = SchoolAnalyticsSubjectMetrics()
)

@Serializable
data class SchoolAnalyticsStudentMetrics(
    val total: Int = 0,
    val active: Int = 0,
    val inactive: Int = 0
)

@Serializable
data class SchoolAnalyticsStaffMetrics(
    val teachers: SchoolAnalyticsCountMetrics = SchoolAnalyticsCountMetrics(),
    @SerialName("school_staff")
    val supportStaff: SchoolAnalyticsCountMetrics = SchoolAnalyticsCountMetrics()
) {
    val total: Int
        get() = teachers.total + supportStaff.total

    val active: Int
        get() = teachers.active + supportStaff.active
}

@Serializable
data class SchoolAnalyticsAcademicYearMetrics(
    val total: Int = 0,
    val active: Int = 0
)

@Serializable
data class SchoolAnalyticsSubjectMetrics(
    val total: Int = 0
)

@Serializable
data class SchoolAnalyticsCountMetrics(
    val total: Int = 0,
    val active: Int = 0
)
